export const SPACING_M = 'spacingM';
export const SPACING_T = 'spacingT';
export const SPACING_D = 'spacingD';
export const VARIATION_OVERLAY = 'overlay';
export const COLUMN_5 = 'column_5';
export const ZERO_WIDTH_COL = '0';

export const BORDER_RADIUS_OVERRIDE_MAP = {
  column_1: ['col1-cta-top', 'col1-cta-bottom'],
  column_2: ['col2-cta-top', 'col2-cta-bottom'],
  column_3: ['col3-cta-top', 'col3-cta-bottom'],
  column_4: ['col4-cta-top', 'col4-cta-bottom'],
  column_5: ['col5-cta-top', 'col5-cta-bottom'],
};

export const HEADER_BORDER_RADIUS_OVERRIDE_MAP = {
  column_1: [
    'col1-header1-top-left',
    'col1-header1-top-right',
    'col1-header1-bottom-left',
    'col1-header1-bottom-right',
  ],
  column_2: [
    'col1-header2-top-left',
    'col1-header2-top-right',
    'col1-header2-bottom-left',
    'col1-header2-bottom-right',
  ],
  column_3: [
    'col1-header3-top-left',
    'col1-header3-top-right',
    'col1-header3-bottom-left',
    'col1-header3-bottom-right',
  ],
  column_4: [
    'col1-header4-top-left',
    'col1-header4-top-right',
    'col1-header4-bottom-left',
    'col1-header4-bottom-right',
  ],
};

export const MEDIA_BORDER_RADIUS_OVERRIDE_MAP = {
  column_1: [
    'col1-media-top-left',
    'col1-media-top-right',
    'col1-media-bottom-left',
    'col1-media-bottom-right',
  ],
  column_2: [
    'col2-media-top-left',
    'col2-media-top-right',
    'col2-media-bottom-left',
    'col2-media-bottom-right',
  ],
  column_3: [
    'col3-media-top-left',
    'col3-media-top-right',
    'col3-media-bottom-left',
    'col3-media-bottom-right',
  ],
  column_4: [
    'col4-media-top-left',
    'col4-media-top-right',
    'col4-media-bottom-left',
    'col4-media-bottom-right',
  ],
};

export const COLUMN_SPACING_OVERRIDE_MAP = {
  column_1: ['col1-spacing-margin-top', 'col1-spacing-margin-bottom'],
  column_2: ['col2-spacing-margin-top', 'col2-spacing-margin-bottom'],
  column_3: ['col3-spacing-margin-top', 'col3-spacing-margin-bottom'],
  column_4: ['col4-spacing-margin-top', 'col4-spacing-margin-bottom'],
  column_5: ['col5-spacing-margin-top', 'col5-spacing-margin-bottom'],
};
